import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "prompt"
};
const _hoisted_2 = {
  class: "hot-words"
};
const _hoisted_3 = {
  class: "group-item"
};
const _hoisted_4 = {
  class: "group-item"
};
const _hoisted_5 = {
  class: "group-item"
};
const _hoisted_6 = {
  class: "btns"
};
import { ImageApi } from '@/api/ai/image';
import { AiPlatformEnum, ImageHotWords, OtherPlatformEnum } from '@/views/aip/utils/constants';
import { ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    models: {
      type: Array,
      default: () => []
    }
  },
  emits: ['onDrawStart', 'onDrawComplete'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    // 接收父组件传入的模型列表
    const props = __props;
    const emits = __emit; // 定义 emits
    // 定义属性
    const drawIn = ref(false); // 生成中
    const selectHotWord = ref(''); // 选中的热词
    // 表单
    const prompt = ref(''); // 提示词
    const width = ref(512); // 图片宽度
    const height = ref(512); // 图片高度
    const otherPlatform = ref(AiPlatformEnum.TONG_YI); // 平台
    const platformModels = ref([]); // 模型列表
    const modelId = ref(); // 选中的模型
    /** 选择热词 */
    const handleHotWordClick = async hotWord => {
      // 情况一：取消选中
      if (selectHotWord.value == hotWord) {
        selectHotWord.value = '';
        return;
      }
      // 情况二：选中
      selectHotWord.value = hotWord; // 选中
      prompt.value = hotWord; // 替换提示词
    };
    /** 图片生成 */
    const handleGenerateImage = async () => {
      // 二次确认
      await message.confirm(`确认生成内容?`);
      try {
        // 加载中
        drawIn.value = true;
        // 回调
        emits('onDrawStart', otherPlatform.value);
        // 发送请求
        const form = {
          platform: otherPlatform.value,
          modelId: modelId.value,
          // 模型
          prompt: prompt.value,
          // 提示词
          width: width.value,
          // 图片宽度
          height: height.value,
          // 图片高度
          options: {}
        };
        await ImageApi.drawImage(form);
      } finally {
        // 回调
        emits('onDrawComplete', otherPlatform.value);
        // 加载结束
        drawIn.value = false;
      }
    };
    /** 填充值 */
    const settingValues = async detail => {
      prompt.value = detail.prompt;
      width.value = detail.width;
      height.value = detail.height;
    };
    /** 平台切换 */
    const handlerPlatformChange = async platform => {
      // 根据选择的平台筛选模型
      platformModels.value = props.models.filter(item => item.platform === platform);
      // 切换平台，默认选择一个模型
      if (platformModels.value.length > 0) {
        modelId.value = platformModels.value[0].id; // 使用 model 属性作为值
      } else {
        modelId.value = undefined;
      }
    };
    /** 监听 models 变化 */
    watch(() => props.models, () => {
      handlerPlatformChange(otherPlatform.value);
    }, {
      immediate: true,
      deep: true
    });
    /** 暴露组件方法 */
    __expose({
      settingValues
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("画面描述")])),
        _: 1
      }), _createVNode(_component_el_text, {
        class: "mt-[5px]",
        tag: "p"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("建议使用“形容词 + 动词 + 风格”的格式，使用“，”隔开")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: prompt.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
        maxlength: "1024",
        rows: 5,
        class: "w-100% mt-[10px]",
        "input-style": "border-radius: 7px;",
        placeholder: "例如：童话里的小屋应该是什么样子？",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("随机热词")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "word-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImageHotWords), hotWord => {
          return _openBlock(), _createBlock(_component_el_button, {
            round: "",
            class: "btn",
            type: selectHotWord.value === hotWord ? 'primary' : 'default',
            key: hotWord,
            onClick: $event => handleHotWordClick(hotWord)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(hotWord), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("平台")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body [&_>div]:!w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: otherPlatform.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => otherPlatform.value = $event),
          placeholder: "Select",
          size: "large",
          class: "!w-full",
          onChange: handlerPlatformChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OtherPlatformEnum), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.name,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("模型")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body [&_>div]:!w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: modelId.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => modelId.value = $event),
          placeholder: "Select",
          size: "large",
          class: "w-100%"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformModels.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("图片尺寸（范围为：[512, 1440]）")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        class: "group-item-body"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: width.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => width.value = $event),
          type: "number",
          class: "w-170px",
          placeholder: "图片宽度"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
          modelValue: height.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => height.value = $event),
          type: "number",
          class: "w-170px",
          placeholder: "图片高度"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: prompt.value.length === 0 ? 'info' : 'primary',
        size: "large",
        round: "",
        loading: drawIn.value,
        disabled: prompt.value.length === 0,
        onClick: handleGenerateImage
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(drawIn.value ? '生成中' : '生成内容'), 1)]),
        _: 1
      }, 8, ["type", "loading", "disabled"])])], 64);
    };
  }
});